import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { API_PATH_PREFIX } from "@dentally/auth/auth-constants";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BaseAuthHttpService {
  constructor(private _http: HttpClient) {}

  public getAccessToken(): Observable<{ accessToken: string }> {
    return this._post<{ accessToken: string }>();
  }

  protected _delete(): Observable<void> {
    return this._http.delete<void>(API_PATH_PREFIX, { withCredentials: true });
  }

  protected _post<T>(pathSuffix = "", body: any = null, options: Record<string, any> = {}): Observable<T> {
    return this._http.post<T>(`${API_PATH_PREFIX}${pathSuffix}`, body, {
      withCredentials: true,
      ...options,
    });
  }
}
